/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";

export type UpdatePromptTemplateResult = {
  /**
   * A prompt template
   */
  template: PromptTemplate;
};

/** @internal */
export const UpdatePromptTemplateResult$inboundSchema: z.ZodMiniType<
  UpdatePromptTemplateResult,
  unknown
> = z.object({
  template: PromptTemplate$inboundSchema,
});

export function updatePromptTemplateResultFromJSON(
  jsonString: string,
): SafeParseResult<UpdatePromptTemplateResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdatePromptTemplateResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdatePromptTemplateResult' from JSON`,
  );
}
